import React, { createContext, useContext, useState } from 'react';

import {
  OpenProtocolContextProviderProps,
  OpenProtocolContextType
} from './interface';

const OpenProtocolContext = createContext({} as OpenProtocolContextType);

export function OpenProtocolContextProvider({ children }: OpenProtocolContextProviderProps) {

  const [nameBrandSelected, setNameBrandSelected] = useState<string>("");

  const [disableCte, setDisableCte] = useState(true);


  const isDisableCte = (value: boolean) => {
    setDisableCte(value);
  };

  const setNameEnterpriseSelectedProtocol = (name: string) => {
    setNameBrandSelected(name);
  };

  return (
    <OpenProtocolContext.Provider
      value={{
        isDisableCte: (value) => isDisableCte(value),
        disableCte,

        setNameEnterpriseSelectedProtocol: (name) => setNameEnterpriseSelectedProtocol(name),
        nameBrandSelected: nameBrandSelected
      }}
    >
      {children}
    </OpenProtocolContext.Provider>
  );
}

export const useOpenProtocolContext = () => {
  return useContext(OpenProtocolContext);
};